"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _FilterLabel = require("../FilterLabel/FilterLabel");
var SuggestedFilterLabel = function SuggestedFilterLabel(_ref) {
  var label = _ref.label,
    description = _ref.description,
    isMobile = _ref.isMobile,
    selected = _ref.selected,
    className = _ref.className;
  return /*#__PURE__*/_react["default"].createElement(_FilterLabel.StyledFilterLabel, {
    className: className,
    selected: selected,
    isMobile: isMobile
  }, /*#__PURE__*/_react["default"].createElement(StyledItemName, null, label), /*#__PURE__*/_react["default"].createElement(StyledItemDescription, null, description));
};
SuggestedFilterLabel.propTypes = {
  className: _propTypes["default"].string
};
SuggestedFilterLabel.defaultProps = {
  className: ''
};
var StyledItemName = _styledComponents["default"].div.withConfig({
  displayName: "SuggestedFilterLabel__StyledItemName",
  componentId: "sc-1lvjcxn-0"
})(["overflow:hidden;text-overflow:ellipsis;"]);
var StyledItemDescription = _styledComponents["default"].div.withConfig({
  displayName: "SuggestedFilterLabel__StyledItemDescription",
  componentId: "sc-1lvjcxn-1"
})(["font-size:", "px;color:", ";"], function (_ref2) {
  var isMobile = _ref2.isMobile;
  return isMobile ? 12 : 10;
}, function (_ref3) {
  var selected = _ref3.selected,
    theme = _ref3.theme;
  return selected ? 'inherit' : theme.colors.greyLight;
});
SuggestedFilterLabel.defaultProps = {
  className: '',
  description: null,
  selected: false,
  isMobile: false
};
SuggestedFilterLabel.propTypes = {
  className: _propTypes["default"].string,
  label: _propTypes["default"].string.isRequired,
  description: _propTypes["default"].string,
  selected: _propTypes["default"].bool,
  isMobile: _propTypes["default"].bool
};
var _default = exports["default"] = /*#__PURE__*/_react["default"].memo(SuggestedFilterLabel);